import React, { type ReactNode, useState } from 'react';

import { SpotlightTarget } from '@atlaskit/onboarding';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Grid, xcss } from '@atlaskit/primitives';
import { PopoverTarget} from '@atlaskit/spotlight';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';

// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths
import { SearchPageOnboardingSpotlight } from '../../../ui/search-page/spotlight';

interface CustomSpotlightTargetProps {
	/**
	 * A single child.
	 */
	children: ReactNode;
	/**
	 * The name to reference from Spotlight.
	 */
	name: string;
}

const gridOverlapStyles = xcss({
	gridRow: 1,
	gridColumn: 1,
});

const spotlightFillStyles = xcss({
	height: '100%',
	width: '100%',
});

const isAboveSmBreakpoint = () => window.innerWidth > 768;

export const CustomSpotlightTarget = ({
	children,
	name,
}: CustomSpotlightTargetProps): React.JSX.Element => {
	const [displaySpotlight] = useState(isAboveSmBreakpoint());

	if (!displaySpotlight) {
		return <React.Fragment>{children}</React.Fragment>;
	}

	return (
		<React.Fragment>
			<Grid>
				<Box xcss={gridOverlapStyles}>
					{expValEquals('company_hub_deprecate_atlaskit_onboarding', 'isEnabled', true)
						? 
						<PopoverTarget>
							<Box xcss={spotlightFillStyles} testId='spotlight-target'/>
						</PopoverTarget>
						: <SpotlightTarget name={name}>
							<Box xcss={spotlightFillStyles} />
						</SpotlightTarget>
					}
				</Box>
				<Box xcss={gridOverlapStyles}>{children}</Box>
			</Grid>
			<SearchPageOnboardingSpotlight />
		</React.Fragment>
	);
};
